import { Column, SectionedCard, StatColumn, StatProps, Text } from "@bridgesplit/ui";
import { explorerAccountUrl } from "@bridgesplit/utils";
import { AddressValue } from "app/components/earn/info/overview/EarnExponentCuratorCard";

export interface OnChainAddressItem {
    label: string;
    address: string;
    href?: string;
}

export function OnChainAddressCard({ addresses }: { addresses?: OnChainAddressItem[] }) {
    const resolveHref = (a: string) => explorerAccountUrl(a);

    const addressStats: StatProps[] | undefined = addresses?.map(({ address, label }) => ({
        caption: label,
        value: <AddressValue address={address} href={resolveHref(address)} />
    }));
    if (addresses && addresses.length === 0) return null;
    return (
        <SectionedCard title="Addresses">
            {!addresses ? (
                <Column spacing={1.5}>
                    <OnChainAddressRowSkeleton />
                    <OnChainAddressRowSkeleton />
                </Column>
            ) : (
                <StatColumn stats={addressStats} />
            )}
        </SectionedCard>
    );
}

function OnChainAddressRowSkeleton() {
    return (
        <Column spacing={0}>
            <Text variant="body2" color="caption" loading loadingWidth="80px">
                &nbsp;
            </Text>
            <Text variant="body2" loading loadingWidth="120px">
                &nbsp;
            </Text>
        </Column>
    );
}
